import '../../../style.css';
import React, { useEffect, useMemo, useRef, useState } from "react";

export default function RightPart({
  poolValues,
  selectedPoolIndex,
  setSelectedPoolIndex,
  onPlace,
  state,
  usedIndexes,
  setUsedIndexes
}) {
  const [dragValue, setDragValue] = useState(null);
  const [dragIndex, setDragIndex] = useState(null);
  const [dragPos, setDragPos] = useState(null);

  const containerRef = useRef(null);


  const handleSelect = (index) => {
    if (usedIndexes[index]) return;

    setSelectedPoolIndex((prev) =>
      prev === index ? null : index
    );
  };

  useEffect(() => {
    if (selectedPoolIndex == null) return;
  }, [selectedPoolIndex]);

  const handleDragStart = (e, value, index) => {
    if (usedIndexes[index]) return;

    setDragValue(value);
    setDragIndex(index);
  };

  const handleDragMove = (e) => {
    if (!dragValue) return;

    setDragPos({
      x: e.clientX,
      y: e.clientY,
    });
  };

  const handleDrop = (e) => {
    if (!dragValue) return;

    const elements = document.elementsFromPoint(
      e.clientX,
      e.clientY
    );

    const slotEl = elements.find((el) =>
      el.dataset && el.dataset.slot
    );

    if (slotEl) {
      const key = slotEl.dataset.slot;

      // call parent logic
      onPlace?.(key, dragIndex);

    }

    setDragValue(null);
    setDragIndex(null);
    setDragPos(null);
  };

  useEffect(() => {
    window.addEventListener("mousemove", handleDragMove);
    window.addEventListener("mouseup", handleDrop);

    return () => {
      window.removeEventListener("mousemove", handleDragMove);
      window.removeEventListener("mouseup", handleDrop);
    };
  });

  const renderCell = (value, index) => {
    const isUsed = usedIndexes[index];
    const isSelected = selectedPoolIndex === index;

    return (
      <div
        key={index}
        onClick={() => handleSelect(index)}
        onMouseDown={(e) =>
          handleDragStart(e, value, index)
        }
        className={`
        w-[20px] h-[20px] sm:w-[24px] sm:h-[24px] sm:w-[26px] sm:h-[26px]
           ${state ? "xl:text-[20px] lg:text-[18px] md:text-[14px] xl:w-[44px] xl:h-[44px] lg:w-[36px] lg:h-[36px] md:w-[28px] md:h-[28px]" : "xl:text-[24px] lg:text-[20px] md:text-[16px] xl:w-[52px] xl:h-[52px] lg:w-[50px] lg:h-[50px] md:w-[36px] md:h-[36px]"}
          flex items-center justify-center
          rounded-[4px] sm:rounded-[6px] lg:rounded-[10px]
          font-bold sm:text-[14px] xs:text-[12px] text-[10px]
          select-none
          transition-all duration-200 text-white
          ${
            isUsed
              ? "bg-[#E7E7E7] pointer-events-none"
              : isSelected
              ? "bg-[#4771B5]"
              : "bg-[#809FD2]"
          }
        `}
      >
        {value}
      </div>
    );
  };

  return (
    <div
      ref={containerRef}
      className={`${state ? "rightpartIsStateWidth" : "rightpartIsNotStateWidth"} z-[50] flex flex-col items-center h-full border-[3px] rounded-[16px] lg:rounded-[20px] border-[#7648B5] bg-[#FFF]`}
    >
      {/* GRID */}
      <div className="flex flex-col justify-evenly flex-1 w-full ">
  {Array.from({ length: Math.ceil(poolValues.length / 2) }).map((_, row) => (
    <div key={row} className="flex justify-evenly">
      {poolValues.slice(row * 2, row * 2 + 2).map((v, i) =>
        renderCell(v, row * 2 + i)
      )}
    </div>
  ))}
</div>

      {/* DRAG PREVIEW */}
      {dragValue != null && dragPos && (
        <div
          className="
            fixed
            w-[50px] h-[50px]
            flex items-center justify-center
            bg-[#4771B5]
            text-white font-bold
            rounded-[10px]
            pointer-events-none
            z-[9999]
          "
          style={{
            left: dragPos.x + 10,
            top: dragPos.y + 10,
          }}
        >
          {dragValue}
        </div>
      )}
    </div>
  );
}